module.exports = __webpack_public_path__ + "static/fragilite-pa-a166859ea6c6d2a2aebc163b836b84ec.svg";